import { z } from 'zod';
export var FlowNotableObject;
(function (FlowNotableObject) {
    FlowNotableObject["AgentConversation"] = "AgentConversation";
    FlowNotableObject["Assistant"] = "Assistant";
    FlowNotableObject["Encounter"] = "Encounter";
    FlowNotableObject["InsuranceOcrResults"] = "InsuranceOcrResults";
    FlowNotableObject["Payment"] = "Payment";
    FlowNotableObject["Template"] = "Template";
    FlowNotableObject["Hl7MessageEvent"] = "Hl7MessageEvent";
    FlowNotableObject["Guarantor"] = "Guarantor";
    FlowNotableObject["ReferenceTable"] = "ReferenceTable";
    FlowNotableObject["PatientOrder"] = "PatientOrder";
    FlowNotableObject["Provider"] = "Provider";
    FlowNotableObject["ExternalDocumentPacket"] = "ExternalDocumentPacket";
    FlowNotableObject["Patient"] = "Patient";
    FlowNotableObject["PatientInsuranceInformation"] = "PatientInsuranceInformation";
    FlowNotableObject["Practice"] = "Practice";
    FlowNotableObject["SftpMessageEvent"] = "SftpMessageEvent";
    FlowNotableObject["X12MessageEvent"] = "X12MessageEvent";
    FlowNotableObject["PatientUpload"] = "PatientUpload";
    FlowNotableObject["PrimaryCareProvider"] = "PrimaryCareProvider";
    FlowNotableObject["FeedMessages"] = "FeedMessages";
    FlowNotableObject["EncounterContacts"] = "EncounterContacts";
    FlowNotableObject["ServiceReviewSubmissions"] = "ServiceReviewSubmissions";
    FlowNotableObject["AuthorizationSubmissions"] = "AuthorizationSubmissions";
    FlowNotableObject["JobContext"] = "JobContext";
})(FlowNotableObject || (FlowNotableObject = {}));
export const BaseFlowNotableObjectConfigSchema = z.object({
    notableObject: z.enum(FlowNotableObject),
});
//# sourceMappingURL=notableObject.js.map